(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5533],{

/***/ 65533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero048": function() { return /* binding */ Hero048; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var _Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62190);
/* harmony import */ var _Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Hero048 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var logos = (ref1 = payload === null || payload === void 0 ? void 0 : payload.logos) !== null && ref1 !== void 0 ? ref1 : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blocks),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading1 */ .nL, {
                        className: (_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headline),
                        children: headline
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default().logos),
                        children: logos.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .ImageLite */ .NH, {
                                image: item.image,
                                className: (_Hero048_module_scss__WEBPACK_IMPORTED_MODULE_2___default().logo)
                            }, item.id);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero048);


/***/ }),

/***/ 62190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero048_wrapper__FVB4y","blocks":"Hero048_blocks___9oWj","logos":"Hero048_logos__adGoY","logo":"Hero048_logo__V_kpZ","wrap":"Hero048_wrap__6YemZ","headline":"Hero048_headline__ug4oz"};

/***/ })

}]);